<script>
import Card from "@/components/atoms/Card";
import * as Units from '@/lib/units';
import * as Id from '@/lib/id';

export default {
  components: { Card },
  props: ["part", "link"],
  computed: {
    price(){
      return Units.getPriceLabel(this.part.price);
    },
    discount(){
      return Units.getPriceDiscount(this.part.price);
    },
    weight(){
      if(this.part.details){
        if(this.part.details["Weight lbs"]){
          if(this.part.details["Weight lbs"].includes("inch")){
            return parseFloat(this.part.details["Weight lbs"])+" lbs per in"
          }else{
            return this.part.details["Weight lbs"];
          }
        }else if(this.part.details.Weight){
          return parseFloat(this.part.details.Weight)+" lbs"
        }else if(this.part.details[" Weight"]){
          return parseFloat(this.part.details[" Weight"])+" lbs"
        }
      }
      return "--";
    },
    vendor(){
      return this.$store.get('parts/getVendorForPart', this.part);
    },
    image_url(){
      return Id.getPartImageURL(this.part.id)
    }
  },
};
</script>

<template>
  <Card
    :link="link"
    :image="image_url"
    :icons="part.details ? part.details['Series'] : null"
    :image-style="part.image ? part.image.style : null"
    :name="part.name" 
    :id="part.id"
    :sub-name="part.sub_name"
    sub-title-left="Weight"
    :sub-value-left="weight"
    sub-title-right="Appx Price"
    :sub-value-right="price"
    :sub-value-right-highlight="discount"
    :vr-id="part.id"
  >
  </Card>
</template>